module.exports = __webpack_public_path__ + "static/media/new_list.b019c0d1.png";